import { render } from "./PhaseCard.vue?vue&type=template&id=c02fc27a&scoped=true"
import script from "./PhaseCard.vue?vue&type=script&lang=js"
export * from "./PhaseCard.vue?vue&type=script&lang=js"

import "./PhaseCard.vue?vue&type=style&index=0&id=c02fc27a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c02fc27a"]])

export default __exports__